import { RenderChannel } from './webChannel';
import { getname } from '../interface/webMasterDriver';
export class CommonBridgeEngine {
    constructor() {
        this.renderChannelApi = new RenderChannel({
            channelId: [getname(location.href), Date.now()].join('-'),
        });
    }
    addWinEvent(eventName, calllback) {
        this.renderChannelApi.addEventListener(eventName, calllback);
    }
    removeWinEvent(eventName, eventId) {
        this.renderChannelApi.removeEventListener(eventName, eventId);
    }
    broadcast2AllWin(businessEventName, params) {
        this.renderChannelApi.invoke({
            eventName: 'broadcastEvent2All',
            params: {
                businessEventName,
                params,
            },
        });
    }
}
